import { CheckmarkCircleIcon, Counter, PlayIcon } from '@ds/components'

import styles from './AudioPlayStats.module.css'

type TStat = {
    count: number
    label: string
}

export type TAudioPlayStatsProps = {
    plays: TStat
    /** Shown only for the audio owner (parity with the current site). */
    likes?: TStat
}

export const AudioPlayStats = ({ plays, likes }: TAudioPlayStatsProps) => {
    const hasLikes = likes !== undefined && likes.count > 0

    if (plays.count <= 0 && !hasLikes) {
        return null
    }

    return (
        <span className={styles.root}>
            {plays.count > 0 ? (
                <Counter Icon={PlayIcon} count={plays.count} label={plays.label} />
            ) : null}
            {hasLikes ? (
                <Counter Icon={CheckmarkCircleIcon} count={likes.count} label={likes.label} />
            ) : null}
        </span>
    )
}
